import { useCallback, useEffect, useState } from 'react'
import { Activity, RefreshCw } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { fetchHealth, DT_STR as S, type ConsoleResult } from './devtoolsApi'

/**
 * A27.14 — Проверка здоровья. Probes the real `/health` endpoint and shows the
 * raw response. FUNCTIONAL (hits the live backend).
 */
export function HealthScreen() {
  const [result, setResult] = useState<ConsoleResult | null>(null)
  const [busy, setBusy] = useState(false)

  const probe = useCallback(async (signal?: AbortSignal) => {
    setBusy(true)
    setResult(await fetchHealth(signal))
    setBusy(false)
  }, [])

  useEffect(() => {
    const ac = new AbortController()
    probe(ac.signal)
    return () => ac.abort()
  }, [probe])

  return (
    <>
      <PageHeader
        title={S.health}
        screenId="A27.14"
        actions={
          <button
            type="button"
            onClick={() => probe()}
            disabled={busy}
            className="inline-flex items-center gap-1.5 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:border-border-strong hover:text-primary disabled:opacity-50"
          >
            <RefreshCw size={13} />
            {S.refresh}
          </button>
        }
      />
      <div className="p-4">
        <div className="mb-2 flex items-center gap-2 text-sm font-medium">
          <Activity size={16} className={result?.ok ? 'text-green-500' : 'text-secondary'} />
          <span className="text-primary">
            {busy ? S.running : result?.ok ? S.ok : result ? S.failed : ''}
          </span>
        </div>
        {result && (
          <pre className="max-h-[420px] overflow-auto rounded-md border border-border-default bg-surface-1 p-3 font-mono text-xs text-primary">
            {typeof result.data === 'string'
              ? result.data
              : JSON.stringify(result.data, null, 2)}
          </pre>
        )}
      </div>
    </>
  )
}
